export default {
    orders: {
        actionUndo: {
            message: "Jeśli kliknąłeś przez pomyłkę, kliknij poniższy link, aby cofnąć.",
            undo: "Kliknij, aby cofnąć"
        }
    }
}